import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IrisApplication, IrisApplicationI, IRIS_APPLICATION_ALIAS } from '@iris/common/models/IrisApplication';
import { catchError, map } from 'rxjs/operators';
import { ApiUrl, IrisApiClientCore } from '@iris/api-query';
import { IrisEnvironmentService } from '@iris/common/services/environment.service';

@Injectable({
  providedIn: 'root',
})
@ApiUrl('/marketplace/{instanceId}/applications')
export class IrisApplicationsService extends IrisApiClientCore {

  constructor() {
    super();
  }

  private readonly _httpClient= inject(HttpClient);
  private readonly _envService= inject(IrisEnvironmentService);

  public getDefaultApplication(): IrisApplication {
    return new IrisApplication({
      id: -1,
      enabled: true,
      applicationAlias: IRIS_APPLICATION_ALIAS,
      name: 'IRIS',
      nameTranslated: 'IRIS',
      description: 'IRIS Platform',
      descriptionTranslated: 'IRIS Platform',
      translations: {},
      logo: 'fa-lg sk-icon sk-icon-lg sk-icon-c-logo',
      projectSelectorEnabled: true,
      globalSearchEnabled: true,
    } as IrisApplicationI);
  }

  public getApplicationList(): Observable<IrisApplication[]> {
    const applications$ = this._httpClient.get<IrisApplicationI[]>(this.url({ instanceId: this._envService.env.instanceId }));
    return applications$.pipe(
      catchError(() => of([])),
      map((applications: IrisApplication[]) => {
        const defaultApplication = this.getDefaultApplication();

        return [defaultApplication, ...applications];
      }),
    );
  }

  public saveApplication(application: IrisApplicationI): Observable<IrisApplicationI> {
    return this._httpClient.post<IrisApplicationI>(this.url({ instanceId: this._envService.env.instanceId }), application);
  }

  @ApiUrl(`~/{id}`)
  public deleteApplication(applicationId: number): Observable<void> {
    return this._httpClient.delete<void>(this.url({ instanceId: this._envService.env.instanceId, id: applicationId }));
  }

  @ApiUrl(`~/{id}`)
  public updateApplication(application: IrisApplicationI): Observable<IrisApplicationI> {
    return this._httpClient.post<IrisApplicationI>(this.url({ instanceId: this._envService.env.instanceId, id: application?.id }), application);
  }
}
